import { Outlet, useNavigate } from "react-router-dom";

import styles from "./style.module.scss";
import { ReactComponent as LogoIcon } from "../../assets/James-Hope-University-Logo.svg";
import { routes } from "../../routes";

const AuthLayout = () => {
  const navigate = useNavigate();
  const handleNavigation = () => navigate(routes.auth.landing);

  return (
    <section className={styles.container}>
      <header className={styles.header}>
        <div>
          <div onClick={handleNavigation}>
            <LogoIcon height="70" />
          </div>
        </div>
      </header>

      <main className={styles.main}>
        <Outlet />
      </main>
    </section>
  );
};

export default AuthLayout;
